export const capitalizeFirstLetter = (string: string) => {
	return `${string.charAt(0).toLocaleUpperCase()}${string
		.slice(1)
		.toLocaleLowerCase()}`
}

export const toTitleCaseWords = (value: string) =>
	value
		.split(' ')
		.filter(Boolean)
		.map((word) => capitalizeFirstLetter(word))
		.join(' ')

export const formatCampaignObjectiveLabel = (value: string) => {
	if (!value) return ''

	const normalized = value.replace(/_/g, ' ').trim()
	const withoutOutcome = normalized.replace(/\bOutcome\b\s*/i, '').trim()

	return toTitleCaseWords(withoutOutcome || normalized)
}

export const capitalizeFirstLetterFromArray = (data: string[]) => {
	return data.map((v) => capitalizeFirstLetter(v))
}

export const truncateString = (value: string, width: number) => {
	if (value.length > width) {
		return value.substring(0, width) + '...'
	} else {
		return value
	}
}
